import { gates } from '../constants/gates';
const keys = {
  CONVERSATIONAL_ENRICHMENT_BETA: 'conversationalEnrichmentBeta',
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: 'conversationalEnrichmentEmploymentChange',
  ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES: 'enrichmentAutoLastEngagementCompanies',
  ENRICHMENT_AUTO_PAUSE: 'enrichmentAutoPause',
  ENRICHMENT_SMART_PROPERTIES: 'enrichmentSmartProperties',
  HUBSPOT_CREDITS: 'hubspotCredits',
  ENRICHMENT_FREE_OPT_OUT: 'enrichmentFreeOptOut',
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE: 'conversationalEnrichmentEmploymentChangeToggle',
  CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE: 'conversationalEnrichmentOutOfOfficeToggle'
};
const gateLookup = {
  [keys.CONVERSATIONAL_ENRICHMENT_BETA]: gates.CONVERSATIONAL_ENRICHMENT_BETA,
  [keys.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE]: gates.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE,
  [keys.ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES]: gates.ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES,
  [keys.ENRICHMENT_AUTO_PAUSE]: gates.ENRICHMENT_AUTO_PAUSE,
  [keys.ENRICHMENT_SMART_PROPERTIES]: gates.ENRICHMENT_SMART_PROPERTIES,
  [keys.HUBSPOT_CREDITS]: gates.HUBSPOT_CREDITS,
  [keys.ENRICHMENT_FREE_OPT_OUT]: gates.ENRICHMENT_FREE_OPT_OUT,
  [keys.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE]: gates.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE,
  [keys.CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE]: gates.CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE
};
export function getGates(options) {
  return Object.keys(options).map(option => options[option] ? gateLookup[option] : null).filter(gate => gate !== null);
}
export function getGate(key) {
  return gateLookup[key];
}